<template>
  <div class="col">
    <form class="form-row" @submit.prevent="submit">
      <div class="col">
        <div class="form-group">
          <input type="text" class="form-control" placeholder="Nome" id="fullName" v-model="fullName" @input="emit"/>
        </div>
      </div>
      <div class="col">
        <div class="form-group">
          <input type="text" class="form-control" id="email" placeholder="Email" v-model="email" @input="emit"/>
        </div>
      </div>
      <div class="col">
        <div class="form-group">
          <input type="text" class="form-control" placeholder="CPF/CNPJ" id="taxDocument" v-model="taxDocument" @input="emit"/>
        </div>
      </div>
      <div class="col">
        <div class="form-group">
          <vue-bootstrap-typeahead
            :data="partnersList"
            v-model="searchPartner"
            :serializer="s => s.referenceName"
            placeholder="Nome do parceiro"
            @hit="selectPartner"
            :minMatchingChars=2
            ref="typeahead"
            />
        </div>
      </div>
      <div class="col">
        <div class="form-group">
          <select class="form-control" id="situation" v-model="situation">
            <option :value="[]" selected="selected">Todos</option>
            <option :value="'pending'">Pendente de análise</option>
            <option :value="'pendingSellerAction'">Pendente de ação do lojista</option>
            <option :value="'incomplete'">Incompleto</option>
            <option :value="'blacklist'">Blacklist</option>
            <option :value="'validated'">Validado</option>
            <option :value="'reproved'">Reprovado</option>
            <option :value="'inactive'">Encerrado</option>
          </select>
        </div>
      </div>
      <div class="col-auto">
        <button type="submit" class="btn btn-info mr-2">
          <i class="icon-magnifier"></i>
        </button>
        <button type="button" class="btn btn-outline-secondary" @click="reset">
          <i class="icon-trash"></i>
        </button>
      </div>
    </form>
  </div>
</template>

<script>
import AccountApi from '@/services/AccountApi'
import _ from 'lodash'
export default {
  name: 'SellerListFilter',
  props: ['value'],
  data () {
    return {
      fullName: null,
      email: null,
      taxDocument: null,
      situation: [],
      partnerId: null,
      searchPartner: null,
      partnersList: []
    }
  },
  async mounted () {
    this.situation[0] = ''
  },
  watch: {
    searchPartner: _.debounce(function (addr) { this.searchPartners(addr) }, 500)
  },
  methods: {
    async getPartnersAll () {
      const api = new AccountApi()
      const result = await api.sellers.getpartners()
      return result.partners
    },
    async searchPartners (query) {
      const api = new AccountApi()
      const result = await api.sellers.searchPartners(query)
      this.partnersList = result.partners
    },
    selectPartner (parameter) {
      this.partnerId = parameter.id.trim()
    },
    emit () {
      this.$emit('input', {
        fullName: this.fullName,
        email: this.email,
        taxDocument: this.taxDocument,
        situation: this.situation[0] === '' ? [] : this.situation,
        partnerId: this.partnerId
      })
    },
    reset () {
      this.fullName = null
      this.email = null
      this.taxDocument = null
      this.situation = []
      this.partnerId = null
      this.searchPartner = null
      this.$refs.typeahead.inputValue = ''

      this.emit()
    },
    submit () {
      this.emit()
      this.$emit('submit')
    }
  }
}
</script>
